export const isLoggedIn = state => state.account.isLoggedIn

export const isSuperuser = state => state.account.isSuperuser

export const isPC = () => !/android|webos|iphone|ipad|ipod|blackberry|iemobile|opera mini/i.test(navigator.userAgent.toLowerCase())



// WEBPACK FOOTER //
// ./src/store/getters.js